module.exports = __webpack_public_path__ + "static/media/main_paper_1.6be51097.png";